import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, Stack, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { closeGettingProDialog, selectGettingProDialog } from '../stateManagement/gettingProDialogSlice';
import { AppDispatch } from '../stateManagement/store';
import EmailIcon from '@mui/icons-material/Email';
import StarIcon from '@mui/icons-material/Star';

const GettingPro: React.FC = () => {
    const gettingProDialog = useSelector(selectGettingProDialog);
    const dispatch = useDispatch<AppDispatch>();

    const handleClose = () => dispatch(closeGettingProDialog());

    return (
        <Dialog
            open={gettingProDialog.open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <StarIcon color="primary" />
                    <Typography variant="h6" fontWeight="bold">
                        Upgrade to Pro
                    </Typography>
                </Stack>
            </DialogTitle>

            <DialogContent dividers>
                <Typography variant="body1" gutterBottom>
                    Unlock advanced features and get the most out of Ontime project.
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Contact us for more details on upgrading to the Pro version.
                </Typography>
                <Box display='flex' justifyContent='center' alignItems='center' mt={2} >
                    <EmailIcon />
                    <Typography variant="body2" ml={1} >
                        MehradParsa23@gmail.com
                    </Typography>
                </Box>

            </DialogContent>

            <DialogActions>
                <Button
                    startIcon={<EmailIcon />}
                    color="primary"
                    variant="contained"
                    href="mailto:MehradParsa23@gmail.com"
                >
                    Contact Us
                </Button>
                <Button onClick={handleClose} color="primary" variant="contained">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default GettingPro;